/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

// No usan variables dinámicas: son un único contador global implícito
// ("Cantidad") en el generador Arduino.

Blockly.Blocks.variables_set_value = {
  init: function () {
    this.setColour(colors.COLOUR_VARIABLES);
    // Constructor Number, no el string: con 'Number' el shadow math_number no
    // conecta y el error aborta el flyout entero.
    this.appendValueInput('NUM')
      .setCheck(Number)
      .appendField(Blockly.Msg.LANG_VARIABLES_SET_VALUE);
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_VARIABLES_SET_VALUE_TOOLTIP);
  },
};

Blockly.Blocks.variables_get_value = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_VARIABLES);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_VARIABLES_GET_VALUE);
    this.setInputsInline(true);
    this.setOutput(true, 'Number');
    this.setTooltip(Blockly.Msg.LANG_VARIABLES_GET_VALUE_TOOLTIP);
  },
};

Blockly.Blocks.variables_add_one = {
  init: function () {
    this.setColour(colors.COLOUR_VARIABLES);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_VARIABLES_ADD_ONE);
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_VARIABLES_ADD_ONE_TOOLTIP);
  },
};

Blockly.Blocks.variables_substract_one = {
  init: function () {
    this.setColour(colors.COLOUR_VARIABLES);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_VARIABLES_SUBSTRACT_ONE);
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_VARIABLES_SUBSTRACT_ONE_TOOLTIP);
  },
};
